import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { Dispatch } from 'redux';
import { RootState } from '../../../stores/store';

interface Props extends LocalizeContextProps, RouteComponentProps {
    dialogType: 'forgot' | 'change';
}

class ForgotPasswordDialog extends React.Component<Props> {
    public render() {
        const t = this.props.translate;
        return (
            <Card color={'success text-white'}>
                <CardBody>
                    {this.props.dialogType === 'forgot' ?
                        <CardTitle tag="h3">{t('forgotPassword.header.forgotPassword')}</CardTitle>
                        : <CardTitle tag="h3">{t('forgotPassword.header.changePassword')}</CardTitle>}
                    <div>
                        <p>{t('forgotPassword.text.success')}</p>

                        {this.props.dialogType === 'forgot' ?
                            (
                                <Link to={{ pathname: '/login', state: { from: this.props.location } }} >
                                    {t('forgotPassword.link.backToLogin')}
                                </Link>
                            ) : (
                                <Link to={{ pathname: '/select-app', state: { from: this.props.location } }} >
                                    {t('forgotPassword.link.backToApps')}
                                </Link>
                            )
                        }
                    </div>
                </CardBody>
            </Card>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(ForgotPasswordDialog)));
